// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  ifObjectGetValue,
  roundAndCastToString,
} from 'helpers/reduxFormFunctions'

const scrubModulationSummary = sems => {
  const maxPower = roundAndCastToString(
    ifObjectGetValue(sems, 'maxPower'),
    1
  )
  const maxThroughput = roundAndCastToString(
    ifObjectGetValue(sems, 'maxThroughput'),
    1
  )
  const minThroughput = roundAndCastToString(
    ifObjectGetValue(sems, 'minThroughput'),
    1
  )
  return `${maxThroughput} - ${minThroughput} / Max ${maxPower} dBm`
}

const scrubRadio = site => {
  const {
    acmFlag,
    atpcEnabled,
    radioFavoriteNumber,
    segmentEndId,
    segmentEndRadioModulation,
  } = site

  const maxPower = (
    segmentEndRadioModulation
      ? segmentEndRadioModulation.maxPower
      : null
  )

  // radioCode can be null if there's no radio assigned to this segmentEnd.
  // in that case, we'll just give empty strings for everything.
  let radioCode = ifObjectGetValue(site, 'radioCode') || ''
  if (radioCode && radioFavoriteNumber !== null) {
    radioCode += `-${radioFavoriteNumber}`
  }

  // a concatenated string of min/max throughputs and max power
  const modulationSummary = (
    radioCode
      ? scrubModulationSummary(segmentEndRadioModulation)
      : ''
  )

  // NOTE - segmentEndId is passed here because there is no ACM data included in the current data model.
  // if the user wants to see the ACM data for this segment end, we'll need to fetch it to display

  return {
    acmFlag,
    atpcEnabled,
    maxPower,
    modulationSummary,
    radioCode,
    segmentEndId,
  }
}

export default scrubRadio
